export default "__VITE_ASSET__LL$wT7GW__"